/*
 *
 * StructureTextInput
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 03-Mar-2025
 */

import StructureTextInput from './StructureTextInput'

export default StructureTextInput
